import { render } from "./training-table.vue?vue&type=template&id=f72c65c4"
import script from "./training-table.vue?vue&type=script&lang=js"
export * from "./training-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__